import { render } from "./InstitucionesSection.vue?vue&type=template&id=77e92642&ts=true"
import script from "./InstitucionesSection.vue?vue&type=script&lang=ts"
export * from "./InstitucionesSection.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__